module.exports = __webpack_public_path__ + "static/media/wallet-light.8e79300c.svg";